import { AnyAction, applyMiddleware, createStore } from 'redux'
import promise from 'redux-promise-middleware'

import reducers, { Store } from './reducers'
import thunk from 'redux-thunk'
import errorMiddleware from './middleware/errorMiddleware'
import { persistStore } from 'redux-persist'

const middleware = applyMiddleware(
    errorMiddleware,
    promise, // Allows for standardised async handlers with FULFILLED, etc.
    thunk, // Allow actions to be methods.
)
const store = createStore<Store, AnyAction, {}, {}>(reducers, middleware)
export const persistor = persistStore(store)

export default store
